import React, { useState, useEffect, useRef } from 'react';
import { useAxios } from '../../../context/AxiosContext';
import { Icon } from '@fluentui/react/lib/Icon';
import ComplexityFilter from './ComplexityFilter';
import SearchDynamicFilter from './SearchDynamicFilter';

const SearchFilter = ({
	setCurrentPage,
	getSearchResults,
	showFilters,
	setShowFilters,
	dynamicFilterTag,
	setDynamicFilterTag,
	setDynamicFilterTagMapping,
	chrysalisdynamicFilterTag,
	setChrysalisDynamicFilterTag,
	pageTypeId,
	enableComplexity,
	searchParam,
	disableClearFilter,
	setDisableClearFilter,
	complexityTag,
    setComplexityTag,
	showChrysalisFilters,
	showSDMPlusFilters,
	setShowChrysalisFilters,
	setShowSDMPlusFilters,
	dynamicFilterTagMapping
}) => {
	// const [complexityTag, setComplexityTag] = useState();
	const { axiosGetService } = useAxios();
	const searchInputRef = useRef(null);
	const [complexities, setComplexities] = useState([]);
	const [dynamicFilterData, setDynamicFilterData] = useState([]);
	const [dynamicSearchText, setDynamicSearchText] = useState({});
	const [dynamicFilterSearchResult, setDynamicFilterSearchResult] = useState(
		{}
	);
	const [dynamicFilterSearchEnable, setDynamicFilterSearchEnable] = useState(
		{}
	);
	const [tempChrysalisDynamicFilterTag, setTempChrysalisDynamicFilterTag] = useState(chrysalisdynamicFilterTag)

	// Temporary state for filters
	const [tempDynamicFilterTag, setTempDynamicFilterTag] = useState({});
	const [tempComplexityTag, setTempComplexityTag] = useState(complexityTag);
	const [tempChrysalisFilters, setTempChrysalisFilters] = useState(chrysalisdynamicFilterTag);
	const [chrysalisFilters, setChrysalisFilters] = useState([]);
	const [tempDynamicFilterTagMapping, setTempDynamicFilterTagMapping] = useState(dynamicFilterTagMapping); // Temporary state for dynamicFilterTagMapping

	const getComplexities = async () => {
		await axiosGetService('api/activities/projectcomplexity').then((res) => {
			const data = res.data.map((item) => {
				return {
					name: item.name,
					id: item.id,
				};
			});
			setComplexities(data);
		});
	};

	const getComplexityTag = async () => {
		await axiosGetService(
			`api/sdmsettings?sdmKey=DefaultComplexityTag`
		).then((response) => {
			const obj = {
				id: response.data[0].value.split(",").at(0),
				name: response.data[0].value.split(",").at(1).toString()
			}
			setComplexityTag(obj);
			setTempComplexityTag(obj); // Initialize temporary state
		});
	};

	const getFilterData = async () => {
		const selectedFiltersIds = [];
		const filterIds = Object.keys(dynamicFilterTag);
		for (const id of filterIds) {
			if (dynamicFilterTag[Number(id)].selectedTagId.length > 0) {
				selectedFiltersIds.push(
					`${Number(id)}` +
					'-' +
					dynamicFilterTag[Number(id)].selectedTagId.toString()
				);
			}
		}
		if(complexityTag !== undefined && complexityTag !== null){
			await axiosGetService(
				`api/sdmartifactmaster/getdynamicfiltersbypagetype?pageTypeId=${pageTypeId}&isFilter=${selectedFiltersIds?.length?true:false}&artifactId=0&filterIds=${selectedFiltersIds.length > 0 ? selectedFiltersIds.join('|') : 0
				}&complexityIds=${complexityTag.id}&searchValue=${searchParam?.length > 0 ? encodeURIComponent(searchParam) : 0
				}`
			).then((response) => {
				const nameMapping = {};
				const filterTag = {};
				const filterTagMapping = {};
				const searchFilterData = {};
				let searchText = {};
				const data = response?.data?.map((item) => {
					return {
						artifactTypeId: item.artifactTypeId,
						artifactTypeName: item.artifactTypeName,
						artifactData: item.artifactData,
					};
				});
				for (const id in data) {
					nameMapping[data[id].artifactTypeId] =
						dynamicFilterSearchEnable[data[id].artifactTypeId];
					filterTag[data[id].artifactTypeId] = {
						artifactTypeId: data[id].artifactTypeId,
						artifactTypeName: data[id].artifactTypeName,
						selectedTagId: [],
					};
					const tag = data[id].artifactData;
					let artifactTag = {};
					for (const tagId in tag) {
						artifactTag = {
							...artifactTag,
							[tag[tagId].id]: tag[tagId].name,
						};
					}
					filterTagMapping[data[id].artifactTypeId] = artifactTag;
					searchText = {
						...searchText,
						[data[id].artifactTypeId]:
							dynamicSearchText[data[id].artifactTypeId] ?? '',
					};
					searchFilterData[data[id].artifactTypeId] = dynamicSearchText[
						data[id].artifactTypeId
					]
						? tag.filter((item) =>
							item.name
								.toLowerCase()
								.includes(
									dynamicSearchText[data[id].artifactTypeId].toLowerCase()
								)
						)
						: [];
				}
				setDynamicFilterSearchResult({ ...searchFilterData });
				setDynamicSearchText({ ...searchText });
				setDynamicFilterTagMapping({ ...filterTagMapping });
				setDynamicFilterSearchEnable({ ...nameMapping });
				setDynamicFilterData([...data]);
				const newDynamicFilter = { ...dynamicFilterTag };
				for (const artifactTypeId in newDynamicFilter) {
					const { artifactData } =
						data.find(({ artifactTypeId: id }) => id == artifactTypeId) ?? [];
					newDynamicFilter[artifactTypeId].selectedTagId = newDynamicFilter[
						artifactTypeId
					].selectedTagId?.filter((tagId) =>
						artifactData?.map(({ id: itemId }) => itemId).includes(tagId)
					);
				}
				if (
					JSON.stringify(dynamicFilterTag) !== JSON.stringify(newDynamicFilter)
				) {
					setDynamicFilterTag(newDynamicFilter);
				}
			});
		}
		
	};

	useEffect(() => {
		if(chrysalisdynamicFilterTag.length===0){
            setTempChrysalisFilters([])
			// setTempChrysalisDynamicFilterTag([chrysalisdynamicFilterTag]);
		}
    }, [chrysalisdynamicFilterTag]);

	const getCHrysalisFilterData = async () => {
		const selectedFiltersIds = [];
		const filterIds = Object.keys(dynamicFilterTag);
		for (const id of filterIds) {
			if (dynamicFilterTag[Number(id)].selectedTagId.length > 0) {
				selectedFiltersIds.push(
					`${Number(id)}` +
					'-' +
					dynamicFilterTag[Number(id)].selectedTagId.toString()
				);
			}
		}
		if(complexityTag !== undefined && complexityTag !== null){
			await axiosGetService(
				`api/chrysalisartifacts`
			).then((response) => {
				if(response?.data){
					setChrysalisFilters(response.data)
					setTempDynamicFilterTagMapping(response.data); // Initialize temporary state
				}
			});
		}
		
	};

	const searchForArtifact = (searchText, artifactTypeId, artifactData) => {
		if (searchText.trim().length > 0) {
			const filteredRoles = artifactData.filter((item) =>
				item.name.toLowerCase().includes(searchText.toLowerCase())
			);
			setDynamicFilterSearchResult((prevState) => ({
				...prevState,
				[artifactTypeId]: filteredRoles,
			}));
		}
		setDynamicSearchText((prevState) => ({
			...prevState,
			[artifactTypeId]: searchText.trim().length > 0 ? searchText : '',
		}));
	};

	useEffect(() => {
		getComplexityTag();
		getComplexities();
	}, []);

	useEffect(() => {
		if (!enableComplexity && dynamicFilterData.length === 0) {

			setDisableClearFilter(true);
		}
	}, [dynamicFilterData])

	useEffect(() => {
		const dynamicRefValue = Object.values(dynamicFilterSearchEnable);
		if (dynamicRefValue.includes(true) && searchInputRef.current) {
			searchInputRef.current.focus();
		}
	}, [dynamicFilterSearchEnable]);

	useEffect(() => {
		if (complexityTag) {
			getFilterData();
			getCHrysalisFilterData()
		}
	}, [complexityTag,tempComplexityTag]);

	const handleApplyFilters = () => {
		// Update the main state with temporary state values
		setCurrentPage(1)
		setDynamicFilterTag(tempDynamicFilterTag);
		setComplexityTag(tempComplexityTag);
		setDynamicFilterTagMapping(tempDynamicFilterTagMapping);
		setChrysalisDynamicFilterTag(tempChrysalisDynamicFilterTag);
		// if(showChrysalisFilters && showSDMPlusFilters && object.keys(tempDynamicFilterTag).length === 0 ){
		// 	setDynamicFilterTag([])
		// }

		// Trigger the API call
		// getFilterData();
		// getCHrysalisFilterData()
		// getSearchResults()
	};

	const handleChrysalisFilterChange = (filterId) => {
		setTempChrysalisFilters((prevState) =>
			prevState.includes(filterId)
				? prevState.filter((id) => id !== filterId)
				: [...prevState, filterId]
		);
		let updatedFilters = tempChrysalisFilters.includes(filterId)
			? tempChrysalisFilters.filter((id) => id !== filterId) // Remove if unchecked
			: [...tempChrysalisFilters, filterId]; // Add if checked
	
		// Set the new state with only checked IDs
		setTempChrysalisFilters(updatedFilters);
		// setChrysalisDynamicFilterTag(updatedFilters);
		setTempChrysalisDynamicFilterTag(updatedFilters)
	};

	return (
		<div
			id="filtersRightPanel"
			className={!showFilters ? 'topicLandingFilters' : ''}
		>
			<div className="filterPanelHeader">
				<h5>Filters</h5>
				<Icon
					iconName="cancel"
					onClick={() => {
						setShowFilters(false);
					}}
					onKeyPress={(e) => {
						if (e.which === 13) {
							setShowFilters(false);
						}
					}}
					tabIndex={0}
					role="button"
					aria-label="Close Filters"
				/>
			</div>
			<div 
			className="filtersPanelBody filterPanel"
			>
				{/* Checkboxes for SDMPlus and Chrysalis */}
				<p className="filterSectionLabel">Sources</p>
				<div 
				style={{borderBottom:'none'}}
				//  className="filtersCategoryPanelSources"
				 >
				<ul style={{listStyle:'none',marginBottom:'0rem',paddingLeft:'10px'}}>
					
						<li key={'SDMPlus'}>
							<label style={{marginBottom:'0rem'}} className="NotificationChkboxContainernew">
								<input
									name='SDMPlus'
									type="checkbox"
									checked={
										showSDMPlusFilters
									}
									onChange={(e) => {
										if(!e.target.checked){
											setTempDynamicFilterTag({})
										}
											if( e.target.checked && Object.keys(tempDynamicFilterTag).length == 0){
												// setTempChrysalisDynamicFilterTag([])
												// setTempChrysalisFilters([])
												setTempDynamicFilterTag({})
											}
											if( e.target.checked && !showChrysalisFilters){
												setTempChrysalisDynamicFilterTag([])
												// setTempChrysalisFilters([])
												// setTempDynamicFilterTag({})
											}
										setShowSDMPlusFilters(e.target.checked)}}
								/>
								<span style={{border:'1px solid #3291e7',width:'12px',height:'12px',borderRadius:0,top:'4px',display:'block',position:'absolute'}} className="CustomCheckmark"></span>
								<span style={{fontWeight:'bold'}} className="filterLabel">SDMPlus</span>
							</label>
							<div className="tabsTitleToolTip">
								<span className="tabsToolTipArrow"></span>
								SDMPlus
							</div>
						</li>
						<li key={'Chrysalis'}>
							<label style={{marginBottom:'0.25rem'}} className="NotificationChkboxContainernew">
								<input
									name='Chrysalis'
									type="checkbox"
									checked={
										showChrysalisFilters
									}
									onChange={(e) =>{ 
										if(!e.target.checked){
											setTempChrysalisDynamicFilterTag([])
											setTempChrysalisFilters([])
										}
										if( e.target.checked && tempChrysalisDynamicFilterTag.length == 0){
										// 	setTempDynamicFilterTag({})
										setTempChrysalisDynamicFilterTag([])
										}
										if( e.target.checked && !showSDMPlusFilters){
											setTempDynamicFilterTag({})
		
										}
									
										setShowChrysalisFilters(e.target.checked)}}
								/>
								<span style={{border:'1px solid #3291e7',width:'12px',height:'12px',borderRadius:0,top:'4px',display:'block',position:'absolute'}} className="CustomCheckmark new"></span>
								<span style={{fontWeight:'bold'}} className="filterLabel">Chrysalis</span>
							</label>
							<div className="tabsTitleToolTip">
								<span className="tabsToolTipArrow"></span>
								Chrysalis
							</div>
						</li>
					
					</ul>
				</div>

				 {/* Show all filters if no checkbox is selected */}
				{!showSDMPlusFilters && !showChrysalisFilters && (
					<>
						{/* SDMPlus Filters */}
						<hr className='hrtags'/>
						<p className="filterSectionLabel">SDMPlus</p>
						<hr className='hrtags'/>
						{enableComplexity && (
							<div style={{borderBottom:'none'}} className="filtersCategoryPanel">
								<div>
									<h6>Complexity</h6>
									<ComplexityFilter
										data={complexities}
										setValue={setTempComplexityTag}
										value={tempComplexityTag}
										telemetryId="2110"
									/>
								</div>
							</div>
						)}

						{dynamicFilterData.map((item) => (
								<div style={{borderBottom:'none'}} className="filtersCategoryPanel" key={item.artifactTypeId}>
									{item.artifactData.length > 5 ? (
										<>
											{dynamicFilterSearchEnable[item.artifactTypeId] ? (
												<div className="rolesSearch">
													<input
														type="text"
														placeholder={`Search for ${item.artifactTypeName}`}
														value={dynamicSearchText[item.artifactTypeId]}
														onChange={(e) => {
															e.persist();
															searchForArtifact(
																e.target.value,
																item.artifactTypeId,
																item.artifactData
															);
														}}
														ref={searchInputRef}
													/>
													<Icon
														className="searchIcon"
														iconName="cancel"
														onClick={() => {
															setDynamicFilterSearchEnable({
																...dynamicFilterSearchEnable,
																[item.artifactTypeId]: false,
															});
															setDynamicSearchText({
																...dynamicSearchText,
																[item.artifactTypeId]: '',
															});
														}}
														onKeyPress={(e) => {
															if (e.which === 13) {
																setDynamicFilterSearchEnable({
																	...dynamicFilterSearchEnable,
																	[item.artifactTypeId]: false,
																});
																setDynamicSearchText({
																	...dynamicSearchText,
																	[item.artifactTypeId]: '',
																});
															}
														}}
														tabIndex={0}
														role="button"
														aria-label="Cancel Search Filter"
													/>
												</div>
											) : (
												<div className="filtersearch">
													<h6>{item.artifactTypeName}</h6>
													<span
														className="searchIcon"
														onClick={() =>
															setDynamicFilterSearchEnable({
																...dynamicFilterSearchEnable,
																[item.artifactTypeId]: true,
															})
														}
														onKeyPress={(e) => {
															if (e.which === 13) {
																setDynamicFilterSearchEnable({
																	...dynamicFilterSearchEnable,
																	[item.artifactTypeId]: true,
																});
															}
														}}
														tabIndex={0}
														role="button"
														aria-label={`Click to search ${item.artifactTypeName}`}
													>
														<Icon iconName="search" className="searchIcon" />
													</span>
												</div>
											)}
										</>
									) : (
										<h6>{item.artifactTypeName}</h6>
									)}
									<SearchDynamicFilter
										data={
											dynamicSearchText[item.artifactTypeId]
												? dynamicFilterSearchResult[item.artifactTypeId]
												: item.artifactData
										}
										value={tempDynamicFilterTag} // Pass temporary state
										setValue={setTempDynamicFilterTag} // Update temporary state
										artifactTypeName={item.artifactTypeName}
										artifactTypeId={item.artifactTypeId}
									/>
								</div>
							))}

						{/* Chrysalis Filters */}
						<hr className='hrtags'/>
						<p className="filterSectionLabel">Chrysalis</p>
						<hr style={{marginTop:0,marginBottom:0}}/>
						<div style={{borderBottom:'none'}} className="filtersCategoryPanel">
						<h6 style={{marginBottom:'0.5rem'}}>Types</h6>
						<ul>
					{chrysalisFilters.map((item,i) => (
						<li key={item.id}>
							<label className="NotificationChkboxContainer">
								<input
									name={item.name}
									type="checkbox"
									checked={
										tempChrysalisFilters.includes(item.id)
									}
									onChange={() => {
										handleChrysalisFilterChange(item.id)
									}}
						
								/>
								<span className="CustomCheckmark"></span>
								<span className="filterLabel">{item.name}</span>
							</label>
							<div className="tabsTitleToolTip">
								<span className="tabsToolTipArrow"></span>
								
									<span key={item.id}>{item.name}</span>
								
							</div>
						</li>
					))}
					</ul>
						</div>
					</>
				)}

				{/* SDMPlus Filters */}
				{showSDMPlusFilters && (
					<>
						<hr className='hrtags'/>
						<p className="filterSectionLabel">SDMPlus</p>
						<hr className='hrtags'/>
						{enableComplexity && (
							<div style={{borderBottom:'none'}} className="filtersCategoryPanel">
								<div>
									<h6>Complexity</h6>
									<ComplexityFilter
										data={complexities}
										setValue={setTempComplexityTag}
										value={tempComplexityTag}
										telemetryId="2110"
									/>
								</div>
							</div>
						)}

						{dynamicFilterData.map((item) => (
								<div style={{borderBottom:'none'}} className="filtersCategoryPanel" key={item.artifactTypeId}>
									{item.artifactData.length > 5 ? (
										<>
											{dynamicFilterSearchEnable[item.artifactTypeId] ? (
												<div className="rolesSearch">
													<input
														type="text"
														placeholder={`Search for ${item.artifactTypeName}`}
														value={dynamicSearchText[item.artifactTypeId]}
														onChange={(e) => {
															e.persist();
															searchForArtifact(
																e.target.value,
																item.artifactTypeId,
																item.artifactData
															);
														}}
														ref={searchInputRef}
													/>
													<Icon
														className="searchIcon"
														iconName="cancel"
														onClick={() => {
															setDynamicFilterSearchEnable({
																...dynamicFilterSearchEnable,
																[item.artifactTypeId]: false,
															});
															setDynamicSearchText({
																...dynamicSearchText,
																[item.artifactTypeId]: '',
															});
														}}
														onKeyPress={(e) => {
															if (e.which === 13) {
																setDynamicFilterSearchEnable({
																	...dynamicFilterSearchEnable,
																	[item.artifactTypeId]: false,
																});
																setDynamicSearchText({
																	...dynamicSearchText,
																	[item.artifactTypeId]: '',
																});
															}
														}}
														tabIndex={0}
														role="button"
														aria-label="Cancel Search Filter"
													/>
												</div>
											) : (
												<div className="filtersearch">
													<h6>{item.artifactTypeName}</h6>
													<span
														className="searchIcon"
														onClick={() =>
															setDynamicFilterSearchEnable({
																...dynamicFilterSearchEnable,
																[item.artifactTypeId]: true,
															})
														}
														onKeyPress={(e) => {
															if (e.which === 13) {
																setDynamicFilterSearchEnable({
																	...dynamicFilterSearchEnable,
																	[item.artifactTypeId]: true,
																});
															}
														}}
														tabIndex={0}
														role="button"
														aria-label={`Click to search ${item.artifactTypeName}`}
													>
														<Icon iconName="search" className="searchIcon" />
													</span>
												</div>
											)}
										</>
									) : (
										<h6>{item.artifactTypeName}</h6>
									)}
									<SearchDynamicFilter
										data={
											dynamicSearchText[item.artifactTypeId]
												? dynamicFilterSearchResult[item.artifactTypeId]
												: item.artifactData
										}
										value={tempDynamicFilterTag} // Pass temporary state
										setValue={setTempDynamicFilterTag} // Update temporary state
										artifactTypeName={item.artifactTypeName}
										artifactTypeId={item.artifactTypeId}
									/>
								</div>
							))}
					</>
				)}

				{/* Chrysalis Filters */}
				{showChrysalisFilters && (
					<>
						{<hr className='hrtags'/>}
						<p className="filterSectionLabel">Chrysalis</p>
						<hr className='hrtags'/>
						<div style={{borderBottom:'none'}} className="filtersCategoryPanel">
						<h6 style={{marginBottom:'0.5rem'}}>Types</h6>
						<ul>
					{chrysalisFilters.map((item,i) => (
						<li key={item.id}>
							<label className="NotificationChkboxContainer">
								<input
									name={item.name}
									type="checkbox"
									checked={
										tempChrysalisFilters.includes(item.id)
									}
									onChange={() => {
										handleChrysalisFilterChange(item.id)
									}}
						
								/>
								<span className="CustomCheckmark"></span>
								<span className="filterLabel">{item.name}</span>
							</label>
							<div className="tabsTitleToolTip">
								<span className="tabsToolTipArrow"></span>
								
									<span key={item.id}>{item.name}</span>
								
							</div>
						</li>
					))}
					</ul>
						</div>
					
					</>
				)}

				{/* Apply Button */}
				
			</div>
			<div style={{position:'sticky',bottom:0,padding:'10px 10px',backgroundColor:'#f8f8f8',borderTop:'1px solid #e0e0e0'}}>
				<hr className='hrtags'/>
			<div className="filtersApplyButton">
					<button onClick={handleApplyFilters}>Apply</button>
				</div>
				</div>
		</div>
	);
};

export default SearchFilter;
